<template>
    <livestream>
      <div class="login" v-if="session.uid == 0">
        Please log in to your account to watch the live-stream.

        <router-link :to="{name: 'Login'}" class="btn btn-block btn-success mt-4">{{ t.login }}</router-link>
        <router-link :to="{name: 'Register'}" class="btn btn-block btn-warning">{{ t.register }}</router-link>
      </div>
      <iframe v-if="session.uid > 0" :src="api+'/api/v2/play-stream/'+match.id+'?access_token='+to" allow="fullscreen" width="100%" height="280" style="border: none" />
    </livestream>
</template>

<script>
export default {
  name: 'liveStream',
  props: ['match'],
  data () {
    return {
      t: this.$root.t,
      api: window.api,
      to: window.auth.accessToken,
      session: window.session
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login {
  background-color: white;
  padding: 40px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/sportsbook/widget/liveStream.vue